<template>
  <div class="devData">
  <div class="manage-header">
      <div><h3>{{$store.state.module1.isChina?'查看数据':'View data'}}</h3><span v-if="arealist">{{proDevNum}}</span></div>
      <div style="position:relative;">
        <el-select :placeholder="$store.state.module1.isChina?'请输入设备名称':'Enter device name'" v-model="devCode" :filter-method="searchDev" filterable style="margin-right:0.2rem;">
          <el-option :label="$store.state.module1.isChina?'请选择设备':'select device'" disabled value=" "></el-option>
          <el-option v-for="item in arealist" :key="item.code" :label="item.dname" :value="item.code"></el-option>
          <el-pagination
            small
            layout="prev, pager, next"
            @current-change="changeNumber"
            :hide-on-single-page="true"
            :page-size="paginationOption.pageSize"
            :current-page="paginationOption.currentPage"
            :pager-count="paginationOption.pagerCount"
            :total="paginationOption.total">
          </el-pagination>
        </el-select>
        <el-date-picker
          v-model="timeValue"
          type="datetimerange"
          :range-separator="$store.state.module1.isChina?'至':'To'"
          :start-placeholder="$store.state.module1.isChina?'开始日期':'start'"
          :end-placeholder="$store.state.module1.isChina?'结束日期':'end'">
        </el-date-picker>
      <el-button type="primary" @click="getLog" style="marginLeft:0.2rem;">{{$store.state.module1.isChina?'确定':'OK'}}</el-button>
    </div>
    </div>
    <div class="section2 Radius">
      <div class="areaList-header">
        <div style="marginLeft:0.2rem;marginTop:0.1rem;"><h3>{{$store.state.module1.isChina?'数据列表':'Data list'}}</h3></div>
      </div>
      <div>
        <el-table :data="deviceLogList" style="width: 100%;marginTop:0.2rem;" v-loading="loading" >
            <el-table-column fixed :label="$store.state.module1.isChina?'设备名称':'Device name'" :width="width*0.7"><template slot-scope="scope">
                <p class="qwe">{{ scope.row.dname }}</p>
            </template></el-table-column>
            <el-table-column fixed :label="$store.state.module1.isChina?'设备号':'SN Num'" :width="width*0.6">
              <template slot-scope="scope">
              <p class="qwe">{{scope.row.dcode}}</p>
              </template>
            </el-table-column>

            <el-table-column v-for="(p,index) in devParams" :key="index" :label="ConfigUnit(p)" :width="width*0.7" prop="p.name" sortable>
              <template slot-scope="scope">
                <p class="qwe">{{configCalue(scope.row[p.name],p.name)}}</p>
              </template>
              </el-table-column>
            <el-table-column fixed="right" :label="$store.state.module1.isChina?'更新时间(GMT+8)':'Update time(GTM+8)'" :width="width" >
              <template slot-scope="scope">
                <p class="qwe">{{scope.row.create_time}}</p>
              </template>
            </el-table-column>
            <!--
            <el-table-column label="O3(μg/m³)" :width="width*0.6" prop="o3" sortable v-show='false'>
              <template slot-scope="scope">
                <p class="qwe">{{scope.row.o3!==null?scope.row.o3:'/'}}</p>
              </template>
            </el-table-column>
            -->
        </el-table>
      <div class="myPage">
        <el-pagination layout="prev, pager, next, jumper" :total="proDevNum" background @current-change="changePage" :current-page="page" :page-size="10">
        </el-pagination>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { stringTime, requestData } from '../../../assets/js/commont.js'
import { Mixin } from '../../../mixins/index.js'
export default {
  name: 'devData',
  mixins: [Mixin],
  inject: ['reToken'],
  components: {

  },
  data () {
    return {
      loading: false,
      width: 190,
      upD: false,
      formLabelWidth: '90px',
      index: '',
      arealist: [],
      word: '',
      devCode: '',
      activeName: [],
      timeValue: '',
      page: 1,
      searchMessage: false,
      startTime: '',
      endTime: '',
      numArr: ['PM2.5', 'HCHO', 'CO2', 'TEMP', 'RH'],
      devParams: null,
      paginationOption: {
        pageSize: 10,  // 每页显示条数
        currentPage: 1, // 当前页面
        pagerCount: 5, // 按钮数
        total: 10  // 总条数
      },
      searchValue: '',
    }
  },
  created () {
    // 获取项目设备列表
    this.getProDev()
    var u = JSON.parse(window.localStorage.getItem('unit'))
    if (u) {
      var item = [
        {
          name: 'PM2.5',
          unit: u.pm25
        },
        {
          name: 'TVOC',
          unit: u.tvoc
        },
        {
          name: 'HCHO',
          unit: u.hcho
        }
      ]
      this.$store.commit('setU', item)
    }
  },
  mounted () {

  },
  methods: {
    changeNumber(e) {
      this.paginationOption.currentPage = e
      this.getProDev()
    },
    searchDev(v) {
      this.paginationOption.currentPage = 1
      this.searchValue = v
      this.getProDev()
    },
    ConfigUnit (p) {
      this.U.forEach(item => {
        if (p.nickname === item.name) {
          p.unit = item.unit
        }
      })
      let result = p.unit? ('(' + p.unit + ')'): ''
      return p.nickname + result
    },
    configCalue (value, name) {
      if (name === 'tvoc') {
        if (this.U[1].unit === 'mg/m³') {
          value = parseFloat(parseFloat(value * 0.0013).toFixed(4))
        }
      } else if (name === 'hcho') {
        if (this.U[2].unit === 'mg/m³') {
          value = parseFloat(parseFloat(value * 0.0012).toFixed(4))
        }
      } else if (name === 'pm25') {
        if (this.U[0].unit === 'mg/m³') {
          value = parseFloat(parseFloat(value * 0.001).toFixed(4))
        }
      } else {
        return value
      }
      return value
    },
    // 获取设备类型
    getType () {
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        codes: this.devCode,
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getDeviceParam(requestData(data)).then(res => {
        this.devParams = res
      })
    },
    qwe () {
      alert(1)
    },
    // 更新表格
    // 页面跳转
    changePage (index) {
      this.page = index
      this.getDeviceLogLi()
    },
    // 获取项目设备列表函数 --------------------------- 接口
    getProDev () {
      var time = stringTime(this.$myTime())
      var data = {
        account: window.localStorage.getItem('account'),
        key: this.searchValue,
        limit: 10,
        page: this.paginationOption.currentPage,
        project_id: window.localStorage.getItem('proId'),
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getProjectDev(requestData(data))
    },
    searchWord () {
      this.arealist = this.projectDev.filter(item => {
        return item.dname.indexOf(this.word) !== -1
      })
    },
    // 获取设备数据函数------------------------------------接口
    getDeviceLogLi () {
      this.loading = true
      var time = stringTime(this.$myTime())
      var time1 = this.endTime ? stringTime(this.endTime) : stringTime(this.$myTime())
      var s = this.$myTime().getTime()
      var time2 = this.startTime ? stringTime(this.startTime) : stringTime(new Date(s - 60 * 60 * 1000 * 24 * 30))
      var data = {
        account: window.localStorage.getItem('account'),
        device_code: this.devCode,
        limit: 10,
        max_time: time1,
        min_time: time2,
        page: this.page,
        project_id: window.localStorage.getItem('proId'),
        token: window.localStorage.getItem('token'),
        ts: time
      }
      this.getDeviceLogList(requestData(data)).then(() => {
        this.loading = false
      })
    },
    // 查询数据按钮
    getLog () {
      this.page = 1
      if (!this.devCode) {
        this.$message({
          message: this.$store.state.module1.isChina ? '请选择列表' : 'select list',
          type: 'warning'
        })
        return
      } else {

      }
      if (this.timeValue) {
        this.startTime = new Date(this.timeValue[0])
        this.endTime = new Date(this.timeValue[1])
        var difTime = this.endTime.getTime() - this.startTime.getTime()
        if (difTime > 30 * 24 * 60 * 60 * 1000) {
          this.$message({
            message: this.$store.state.module1.isChina ? '时间间隔不能超过30天' : 'The time interval cannot exceed 30 days',
            type: 'warning'
          })
          return
        } else if (this.endTime.getTime() > this.$myTime().getTime()) {
          this.$message({
            message: this.$store.state.module1.isChina ? '时间不能超过当前时间' : 'The time cannot exceed the current time',
            type: 'warning'
          })
          return
        } else {

        }
      }
      this.getDeviceLogLi()
    }
  },
  destoryed () {
    window.onload = null
    window.onresize = null
  },
  watch: {
    projectDev (value) {
      this.$nextTick(() => {
        this.arealist = value
        this.paginationOption.total = this.$store.state.module1.proDevNum
        // this.devCode = value[0].code
        // 获取项目设备列表
        // this.getDeviceLogLi()
      })
    },
    // 增加修改后刷新页面
    File (value) {
      this.$nextTick(() => {
        this.getProDev()
      })
    },
    timeValue (value) {

    },
    devCode () {
      this.$nextTick(() => {
        this.getType()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.upDown{
transition: all 0.4s;
transform :rotate(90deg);
}
.devData{
  width:100%;
  height:100%;
}
.section2{
  height:calc(100% - 1.76rem);
  overflow:auto;
  padding:0.1rem;
  .qwe{
    text-align:center;
    font-size:0.12rem;
    position:relative;
    i{
      margin:0 0.1rem;
      font-size:0.18rem;
    }
    span{
      font-size:0.12rem;
      font-weight:100;
      margin-left:0.03rem;
      color:grey;
      opacity:0.8;
    }
  }
  .qa{
    font-weight:600;
    color:black;
  }
}

.myPage{
  margin-top:0.4rem;
}
.areaList-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    div:first-child{
      display:flex;
      align-items:baseline;
      span{
        color:#01A3FF;
        margin-left:0.2rem;
        font-weight:600;
        font-size:0.14rem;
      }
    }
  }
  .mafan{
    font-size:0.16rem;
    margin:0 0.1rem;
  }
  .xiala{
    display:flex;
    align-items:center;
    padding:0 0.2rem;
    button{
      margin-left:0.4rem;
    }
  }
  .actionMessage{
    display:inline-block;
    text-align:left;
    width:100%;
    padding-left:0.2rem;
    padding-top:0.1rem;
    opacity:0.8;
    font-size:0.14rem;
    color:red;
  }
.manage-header{
    width:calc(100% + 0.48rem);
    height:1.76rem;
    transform:translate(-0.1rem,-0.1rem);
    background:white;
    box-shadow:inset 8px 8px 8px 2px rgba(0,0,0,0.04);
    text-align:left;
    padding-top:0.4rem;
    padding-left:0.4rem;
    h3{
        margin-bottom:0.2rem;
    }
    div:last-child{
        width:100%;
        height:0.4rem;
        padding:0 0.2rem;
        line-height:0.4rem;
        display:flex;
        align-items:center;
        justify-content:flex-start;
    }
    div:first-child{
      display:flex;
      align-items:baseline;
      span{
        color:#01A3FF;
        margin-left:0.2rem;
        font-weight:600;
        font-size:0.14rem;
      }
    }
}
.el-pagination {
  font-size: 24px;
}
</style>
